import { useEnvContext } from "context/EnvContext";
import authApi from "core/model/api/endpoints/auth";
import { BaseEventSchema } from "core/validationSchemas/tracking";
import {
  SpinnerPage,
  SpinnerPageContainer,
} from "ds_legacy/components/Spinner";
import React, { useEffect, useState } from "react";
import { useTracking } from "react-tracking";
import { useAppSelector, useOnLogout } from "reduxentities/hooks";
import { accountDetails } from "../Intercom";

export default function HealthCheck({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isReceiverApp, isSenderApp } = useEnvContext();
  const [valid, setIsValid] = useState(false);
  const auth = useAppSelector(({ auth }) => auth);
  const { first_name, last_name } = accountDetails(
    auth?.identification?.account,
  );
  const onLogout = useOnLogout();

  const { Track } = useTracking<DeepPartial<BaseEventSchema>>(
    {
      user_information: {
        careprovider_id: isReceiverApp ? auth?.careprovider ?? null : null,
        careprovider_name: isReceiverApp
          ? auth?.careprovider_name ?? null
          : null,
        careseeker_id: isSenderApp ? auth?.careseeker ?? null : null,
        careseeker_name: isSenderApp ? auth?.careseeker_name ?? null : null,
        first_name: first_name ?? null,
        last_name: last_name ?? null,
      },
    },
    { dispatchOnMount: false },
  );

  const { config } = useEnvContext();

  useEffect(() => {
    async function validateSession() {
      if (auth?.credentials?.token) {
        try {
          await authApi.checkToken();
          console.log("%c token check [ valid ]", "color: #005a9c");
          setIsValid(true);
        } catch (_) {
          console.log("%c token check [ invalid ]", "color: #005a9c");
          onLogout({ tokenExpired: true });
        }
      } else {
        setIsValid(true);
      }
    }

    if (!valid) {
      validateSession();
    }
  }, [auth, valid, config]);

  if (!valid) {
    return (
      <Track>
        <SpinnerPageContainer>
          <SpinnerPage id="health-check" />
        </SpinnerPageContainer>
      </Track>
    );
  }

  return <Track>{children}</Track>;
}
